import * as React from "react"
import { 
  Edit, 
  TabbedForm, 
  TextInput, 
  required, 
  ImageInput, 
  ImageField, 
  ArrayInput, 
  SimpleFormIterator, 
  FileInput, 
  FileField, 
  ReferenceInput, 
  SelectArrayInput, 
  NumberInput,
  BooleanInput,
  useEditController,
  Toolbar,
  SaveButton,
  DeleteWithConfirmButton
} from "react-admin"
import { useState, useEffect, useRef } from "react";
import {InputAdornment, Grid, Box, Typography } from "@mui/material"

import ImagesTab from "./ImagesTab"
import BasicInfoTab from "./BasicInfoTab"
import ColorOptionsTab from "./ColorOptionsTab"
import EditableAreasTab from "./EditableAreasTab"
import QuantityDiscountsTab from "./QuantityDiscountsTab"
import SpecificationsTab from "./SpecificationsTab"
import DescriptionTab from "./DescriptionTab"
import { validateForm } from "./ProductCreate"

const ProductTitle = () => {
  return <span>{'商品'}</span>;
};

const ProductToolbar = () => {
  return (
    <Toolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        <SaveButton />
        <DeleteWithConfirmButton
          confirmTitle="確認刪除"
          confirmContent="您確定要刪除此商品嗎？"
        />
      </Box>
    </Toolbar>
  );
};

// const validateForm = values => {
//   const errors = {}
//   if (!values.name) {
//     errors.name = "ra.validation.required"
//   }
//   if (values.categories.length === 0) {
//     errors.categories = "ra.validation.required"
//   }
//   if (!values.coverImage?.rawFile && !values.coverImage?.[0]?.title) {
//     errors.coverImage = "ra.validation.required"
//   }
//   if (!values.templateImage?.rawFile && !values.templateImage?.[0]?.title) {
//     errors.templateImage = "ra.validation.required"
//   }
//   if (!values.price) {
//     errors.price = "ra.validation.required"
//   }
//   if (!values.minQuantity) {
//     errors.minQuantity = "ra.validation.required"
//   }
//   if (!values.maxQuantity) {
//     errors.maxQuantity = "ra.validation.required"
//   }
//   if (!values.incrementStep) {
//     errors.incrementStep = "ra.validation.required"
//   }
//   if (!values.specifications) {
//     errors.specifications = "ra.validation.required"
//   }
//   if (values.specifications) {
//     let validate = false;
//     values.specifications.forEach((item) => {
//       if (item.name) {
//         validate = true;
//       }
//     });
//     if (!validate) errors.specifications = "ra.validation.required";
//   }
//   if (values.editableAreas) {
//     errors.editableAreas = [];
  
//     values.editableAreas.forEach((area, index1) => {
//       if (area.areaName) {
        
//         if (!area.templateImage || (!area.templateImage.rawFile && !area.templateImage?.[0]?.title)) {
//           errors.editableAreas[index1] = errors.editableAreas[index1] || {}; 
//           errors.editableAreas[index1].templateImage = "ra.validation.required";
//         }
  
//         if (area.images && Array.isArray(area.images)) {
//           area.images.forEach((item, index2) => {
//             if (!item.image || (!item.image.rawFile && !item.image?.[0]?.title)) {
//               errors.editableAreas[index1].images = errors.editableAreas[index1].images || [];
//               errors.editableAreas[index1].images[index2] = errors.editableAreas[index1].images[index2] || {}; 
//               errors.editableAreas[index1].images[index2].image = "ra.validation.required";
//             }
//           });
//         }
//       }
//     });
//   }
//   if (values.quantityDiscounts) {
//     errors.quantityDiscounts = [];
  
//     values.quantityDiscounts.forEach((item, index) => {
//       if (item.minQuantity && item.maxQuantity && !item.discountPrice) {
//         errors.quantityDiscounts[index] = errors.quantityDiscounts[index] || {}; 
//         errors.quantityDiscounts[index].discountPrice = "ra.validation.required";
//       }
//     });
//   }
//   return errors
// }

const getDefaultValues = (record) => {
  if (!record) return {};

  return {
    sorting: 1,
    code: "",
    name: "",
    categories: [],
    price: 0,
    stock: 0,
    minOrderQuantity: 1,
    maxOrderQuantity: "",
    samplingTime: "",
    samplingFee: "",
    minQuantity: 1,
    maxQuantity: 10,
    incrementStep: 1,
    description: "",
    specification: "",
    status: 1,
    coverImage: [],
    templateImage: [],
    colors: [
      {
        name: "",
        code: "",
        navImage: [],
        image: [],
      }
    ],
    specifications: [
      {
        name: "",
      }
    ],
    quantityDiscounts: [
      {
        minQuantity: "",
        maxQuantity: "",
        discountPercentage: "",
        leadTimeDays: "",
        discountPrice: record.price,
      }
    ],
    editableAreas: [
      {
        areaName: "",
        templateImage: "",
        images: [
          {
            name: "",
            image: [],
          }
        ]
      }
    ]
  };
};

const ProductEdit = () => {
  const controllerProps = useEditController();
  const record = controllerProps.record;

  return (
  <Edit title={<ProductTitle/>} redirect={false} mutationMode="optimistic">
    <TabbedForm 
      defaultValues={getDefaultValues(record)}
      validate={validateForm}
      toolbar={<ProductToolbar />}
    >
      <TabbedForm.Tab
        label="resources.products.tabs.image"
        sx={{ maxWidth: "50em" }}
      >
        <ImagesTab />
      </TabbedForm.Tab>
      <TabbedForm.Tab
        label="基本資料"
        path="basic"
        sx={{ maxWidth: "50em" }}
      >
        <BasicInfoTab />
      </TabbedForm.Tab>
      <TabbedForm.Tab
        label="顏色選項"
        path="color-options"
        sx={{ maxWidth: "50em" }}
      >
        <ColorOptionsTab />
      </TabbedForm.Tab>
      <TabbedForm.Tab
        label="規格選項"
        path="specification-options"
        sx={{ maxWidth: "50em" }}
      >
        <SpecificationsTab />
      </TabbedForm.Tab>
      <TabbedForm.Tab
        label="數量折扣規則"
        path="quantity-discounts"
        sx={{ maxWidth: "50em" }}
      >
        <QuantityDiscountsTab />
      </TabbedForm.Tab>
      <TabbedForm.Tab
        label="編輯區域"
        path="editable-areas"
        sx={{ maxWidth: "50em" }}
      >
        <EditableAreasTab />
      </TabbedForm.Tab>
      <TabbedForm.Tab
        label="描述"
        path="description"
        sx={{ maxWidth: "50em" }}
      >
        <DescriptionTab />
      </TabbedForm.Tab>
    </TabbedForm>
  </Edit>
  )
}

export default ProductEdit